'use client';
import { useTranslations } from 'next-intl';

import { BasicProductDataResponse, BranchResponse } from '@/src/types/catalog';
import { ProductCard } from '@/src/app/[locale]/stores/[store]/[storeId]/product/components/ProductCard';
import { TCountryId, TCurrency } from '@/src/components/sarComponent';

export const SimilarProducts = ({
  similarProductsInfo,
  branchId,
  countryId,
  currencyCode,
  englishBranchName,
  englishStoreName,
  storeArabicName,
}: {
  similarProductsInfo?: (BasicProductDataResponse & {
    integrationId: string;
  })[];
  branchId: string | number;
  currencyCode: TCurrency;
  countryId: TCountryId;
  englishStoreName?: string;
  storeArabicName?: string;
  englishBranchName?: string | null;
}) => {
  const t = useTranslations('product');

  if (!Boolean(similarProductsInfo?.length)) return null;

  const enrichedProducts = similarProductsInfo?.map((item) => ({
    ...item,
    storeEnglishName: englishStoreName,
    branchName: englishBranchName,
    storeArabicName: storeArabicName,
  }));

  return (
    <section className="mx-auto max-w-[1440px] py-5">
      <h2 className="mt-1 mb-5 text-xl font-bold capitalize">{t('similar products')}</h2>
      <div className="styled-scroll flex flex-nowrap gap-5 overflow-auto px-2 pb-3 transition-all duration-300">
        {enrichedProducts?.map((item, index) => {
          return (
            <div key={index} className="shrink-0 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5">
              <ProductCard
                productDetails={item as BasicProductDataResponse}
                scroll
                branchId={branchId}
                branchCurrency={currencyCode}
                branchCountryId={countryId}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};
